import {Component, Input} from '@angular/core';
import {IoniconsFilled, IoniconsOutline, PtEntity} from '@pt/pt-models';

@Component({
  selector: 'pt-entity-icon',
  template: `
    <div class="position-relative">
      <ng-container [ngSwitch]="entity">
        <img
          alt="dataBreach"
          *ngSwitchCase="'dataBreach'"
          [src]="'assets/images/entities/dataBreach.svg'"
          [width]="width"
        />
        <img
          alt="legalEntity"
          *ngSwitchCase="'legalEntity'"
          [src]="'assets/images/entities/legalEntity.svg'"
          [width]="width"
        />
        <img
          alt="organizationalFunctions"
          *ngSwitchCase="'organizationalFunctions'"
          [src]="'assets/images/entities/organizationalFunctions.svg'"
          [width]="width"
        />
        <img
          alt="userResources"
          *ngSwitchCase="'userResources'"
          [src]="'assets/images/entities/userResources.svg'"
          [width]="width"
        />
        <img
          alt="privacyRole"
          *ngSwitchCase="'privacyRole'"
          [src]="'assets/images/entities/privacyRole.svg'"
          [width]="width"
        />
        <img
          alt="employmentRelationship"
          *ngSwitchCase="'employmentRelationship'"
          [src]="'assets/images/entities/employmentRelationship.svg'"
          [width]="width"
        />
        <img
          alt="treatmentCategory"
          *ngSwitchCase="'treatmentCategory'"
          [src]="'assets/images/entities/treatmentCategory.svg'"
          [width]="width"
        />
        <img
          alt="applications"
          *ngSwitchCase="'applications'"
          [src]="'assets/images/entities/applications.svg'"
          [width]="width"
        />
        <img
          alt="applicationTypes"
          *ngSwitchCase="'applicationTypes'"
          [src]="'assets/images/entities/applicationTypes.svg'"
          [width]="width"
        />
        <img
          alt="regulations"
          *ngSwitchCase="'regulations'"
          [src]="'assets/images/entities/regulations.svg'"
          [width]="width"
        />
        <img
          alt="notices"
          *ngSwitchCase="'notices'"
          [src]="'assets/images/entities/notices.svg'"
          [width]="width"
        />
        <img
          alt="natureOfData"
          *ngSwitchCase="'natureOfData'"
          [src]="'assets/images/entities/natureOfData.svg'"
          [width]="width"
        />
        <img
          alt="interestedPersonCategories"
          *ngSwitchCase="'interestedPersonCategories'"
          [src]="'assets/images/entities/interestedPersonCategories.svg'"
          [width]="width"
        />
        <img
          alt="recipients"
          *ngSwitchCase="'recipients'"
          [src]="'assets/images/entities/recipients.svg'"
          [width]="width"
        />
        <img
          alt="suppliers"
          *ngSwitchCase="'suppliers'"
          [src]="'assets/images/entities/suppliers.svg'"
          [width]="width"
        />
        <img
          alt="damage"
          *ngSwitchCase="'damage'"
          [src]="'assets/images/entities/damage.svg'"
          [width]="width"
        />

        <img
          alt="treatmentsHolder"
          *ngSwitchCase="'treatmentsHolder'"
          [src]="'assets/images/entities/treatmentsHolder.svg'"
          [width]="width"
        />
        <img
          alt="treatmentsHolderValidated"
          *ngSwitchCase="'treatmentsHolderValidated'"
          [src]="'assets/images/entities/treatmentsHolderValidated.svg'"
          [width]="width"
        />

        <img
          alt="treatmentsResponsible"
          *ngSwitchCase="'treatmentsResponsible'"
          [src]="'assets/images/entities/treatmentsResponsible.svg'"
          [width]="width"
        />
        <img
          alt="treatmentsResponsibleValidated"
          *ngSwitchCase="'treatmentsResponsibleValidated'"
          [src]="'assets/images/entities/treatmentsResponsibleValidated.svg'"
          [width]="width"
        />

        <img
          alt="treatmentsSubResponsible"
          *ngSwitchCase="'treatmentsSubResponsible'"
          [src]="'assets/images/entities/treatmentsSubResponsible.svg'"
          [width]="width"
        />
        <img
          alt="treatmentsSubResponsibleValidated"
          *ngSwitchCase="'treatmentsSubResponsibleValidated'"
          [src]="'assets/images/entities/treatmentsSubResponsibleValidated.svg'"
          [width]="width"
        />

        <img
          alt="projectCards"
          *ngSwitchCase="'projectCards'"
          [src]="'assets/images/entities/projectCards.svg'"
          [width]="width"
        />
        <img
          alt="projectCardsValidated"
          *ngSwitchCase="'projectCardsValidated'"
          [src]="'assets/images/entities/projectCardsValidated.svg'"
          [width]="width"
        />

        <img
          alt="appAssessment"
          *ngSwitchCase="'appAssessment'"
          [src]="'assets/images/entities/appAssessment.svg'"
          [width]="width"
        />
        <img
          alt="appAssessmentValidated"
          *ngSwitchCase="'appAssessmentValidated'"
          [src]="'assets/images/entities/appAssessmentValidated.svg'"
          [width]="width"
        />

        <img
          alt="globalMeasureCheck"
          *ngSwitchCase="'globalMeasureCheck'"
          [src]="'assets/images/entities/globalMeasureCheck.svg'"
          [width]="width"
        />
        <img
          alt="globalMeasureCheckValidated"
          *ngSwitchCase="'globalMeasureCheckValidated'"
          [src]="'assets/images/entities/globalMeasureCheckValidated.svg'"
          [width]="width"
        />

        <img
          alt="aiAssessment"
          *ngSwitchCase="'aiAssessment'"
          [src]="'assets/images/entities/aiAssessment.svg'"
          [width]="width"
        />
        <img
          alt="aiAssessmentValidated"
          *ngSwitchCase="'aiAssessmentValidated'"
          [src]="'assets/images/entities/aiAssessmentValidated.svg'"
          [width]="width"
        />

        <img
          alt="covidAssessment"
          *ngSwitchCase="'covidAssessment'"
          [src]="'assets/images/entities/covidAssessment.svg'"
          [width]="width"
        />
        <img
          alt="covidAssessmentValidated"
          *ngSwitchCase="'covidAssessmentValidated'"
          [src]="'assets/images/entities/covidAssessmentValidated.svg'"
          [width]="width"
        />

        <img
          alt="appointments"
          *ngSwitchCase="'appointments'"
          [src]="'assets/images/entities/appointments.svg'"
          [width]="width"
        />
        <img
          alt="appointmentsAuthorized"
          *ngSwitchCase="'appointmentsAuthorized'"
          [src]="'assets/images/entities/appointmentsAuthorized.svg'"
          [width]="width"
        />
        <img
          alt="appointmentsResponsible"
          *ngSwitchCase="'appointmentsResponsible'"
          [src]="'assets/images/entities/appointmentsResponsible.svg'"
          [width]="width"
        />
        <img
          alt="appointmentsSystemAdmin"
          *ngSwitchCase="'appointmentsSystemAdmin'"
          [src]="'assets/images/entities/appointmentsSystemAdmin.svg'"
          [width]="width"
        />
        <img
          alt="purpose"
          *ngSwitchCase="'purpose'"
          [src]="'assets/images/entities/purpose.svg'"
          [width]="width"
        />
        <img
          alt="purposeCategory"
          *ngSwitchCase="'purposeCategory'"
          [src]="'assets/images/entities/purpose.svg'"
          [width]="width"
        />
        <img
          alt="legalBasis"
          *ngSwitchCase="'legalBasis'"
          [src]="'assets/images/entities/legalBasis.svg'"
          [width]="width"
        />
        <img
          alt="organizationalMeasures"
          *ngSwitchCase="'organizationalMeasures'"
          [src]="'assets/images/entities/organizationalMeasures.svg'"
          [width]="width"
        />
        <img
          alt="organizationalMeasureCategories"
          *ngSwitchCase="'organizationalMeasureCategories'"
          [src]="'assets/images/entities/organizationalMeasureCategories.svg'"
          [width]="width"
        />
        <img
          alt="preliminaryRiskAssessment"
          *ngSwitchCase="'preliminaryRiskAssessment'"
          [src]="'assets/images/entities/preliminaryRiskAssessment.svg'"
          [width]="width"
        />
        <img
          alt="technicalMeasures"
          *ngSwitchCase="'technicalMeasures'"
          [src]="'assets/images/entities/technicalMeasures.svg'"
          [width]="width"
        />
        <img
          alt="technicalMeasureCategories"
          *ngSwitchCase="'technicalMeasureCategories'"
          [src]="'assets/images/entities/technicalMeasureCategories.svg'"
          [width]="width"
        />
        <img
          alt="users"
          *ngSwitchCase="'users'"
          [src]="'assets/images/entities/users.svg'"
          [width]="width"
        />
        <img
          alt="consoleUsers"
          *ngSwitchCase="'consoleUsers'"
          [src]="'assets/images/entities/users.svg'"
          [width]="width"
        />
        <img
          alt="dpia"
          *ngSwitchCase="'dpia'"
          [src]="'assets/images/entities/dpia.svg'"
          [width]="width"
        />

        <img
          alt="folder"
          *ngSwitchCase="'folder'"
          [src]="'assets/images/icon-svg/folder.svg'"
          [width]="width"
        />

        <img
          alt="missingImage"
          *ngSwitchDefault
          [src]="'assets/images/missing-image.png'"
          [width]="width"
        />
      </ng-container>
      <pt-icon
        [key]="IconValidated"
        class="validated"
        *ngIf="entity.endsWith('Validated')"
        [size]="12"
      ></pt-icon>
    </div>
  `,
  styles: [
    `
      img {
        /*display: flex;*/
      }
      .validated {
        color: #333333;
        /* #00bb00;*/
        position: absolute;
        top: 6px;
        left: 8px;
      }
    `,
  ],
})
export class EntityIconComponent {
  @Input() entity: PtEntity;
  @Input() width = 20;

  IconValidated = IoniconsFilled.camera;
}


